<div class="with-floating-button">
    <div class="content">
        <list-view [liste]="liste" *ngIf="liste"></list-view>
    </div>
</div>
